const useSearchMap = () => {

  const handleAutoComplete = async (keyword) => {
    try {
      const result = await fetch(`https://maps.track-asia.com/api/v1/autocomplete?lang=vi&text=${keyword}&key=public_key`)
      const addresses = await result.json()
      const listAddresses = addresses.features.map((item) =>{ 
        return {
          id: item.properties.id,
          label: item.properties.label,
          region: item.properties.region,
          county: item.properties.county,
          lat: item.geometry.coordinates[1],
          lon: item.geometry.coordinates[0],
        };
      });
      return listAddresses
    } catch (error) {
      throw new Error((error).message);
    }
  };
  return { handleAutoComplete };
};

export default useSearchMap;
